import { useSetRecoilState } from "recoil"
import { accountState, flowState } from "../recoil"
import { login, ILoginRequest, setAccountInfo, setFlow, clearFlow } from '../api'
import { LoginInfoModel } from "../models"

export const useAccount = () => {
    const setAccountState = useSetRecoilState(accountState.accountDataState)
    const setFlowDataState = useSetRecoilState(flowState.flowDataState)

    const loginAsync = async (payload: ILoginRequest) => {
        return await login(payload).then(res => {
            const _account = new LoginInfoModel({
                ...res,
                loginSession: {
                    ...res.loginSession,
                    userLocalType: "ADMIN"
                }
            })
            setAccountState(_account)
            setAccountInfo(_account)
            return _account
        })
    }

    const logout = () => {
        localStorage.clear()
        setAccountState(new LoginInfoModel({}))
    }

    const setFlowForApp = (flow: string) => {
        setFlow(flow)
        setFlowDataState({ flow })
    }

    const clearFlowForApp = () => {
        clearFlow()
        setFlowDataState({ flow: null })
    }

    return {
        loginAsync,
        setFlowForApp,
        clearFlowForApp,
        logout
    }
}